import { render, staticRenderFns } from "./reporteAsignacionPolizas.vue?vue&type=template&id=ddadf9ee&scoped=true"
import script from "./reporteAsignacionPolizas.vue?vue&type=script&lang=js"
export * from "./reporteAsignacionPolizas.vue?vue&type=script&lang=js"
import style0 from "./reporteAsignacionPolizas.vue?vue&type=style&index=0&id=ddadf9ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddadf9ee",
  null
  
)

export default component.exports